/* eslint-disable no-plusplus */
import sortBy from 'lodash/sortBy';
import { linearChannelsChannelListSelector } from 'app-webtech-core/modules/linearChannels/selectors/channelList';
import { linearChannelsCategoryListSelector } from 'app-webtech-core/modules/linearChannels/selectors/categoryList';
import { linearChannelsFetchAllApiThunkAction } from 'app-webtech-core/modules/linearChannels/actions/fetchAll';
import { GUIDE_LIST_ITEM_KIND } from '../constants';
import { guideSetListAction } from './setList';

const featuredKey = 'featured';

const groupByCategory = ({ channels, categories, includeFeatured = true }) =>
  channels.reduce((collection, channel) => {
    const groupedChannels = collection.get(categories[channel.categoryID].name) || [];

    collection.set(categories[channel.categoryID].name, [...groupedChannels, channel]);

    if (channel.featured && includeFeatured) {
      const groupedFeaturedChannels = collection.get(featuredKey) || [];

      collection.set(featuredKey, sortBy([...groupedFeaturedChannels, channel], ['featuredOrder']));
    }

    return collection;
  }, new Map([[featuredKey]]));

const categoryFactory = ({ name, offset, index, images }) => ({
  kind: GUIDE_LIST_ITEM_KIND.CATEGORY,
  name,
  nameKey: name === featuredKey ? featuredKey : undefined,
  offset,
  index,
  images,
});

const channelFactory = ({ id, offset, index }) => ({
  kind: GUIDE_LIST_ITEM_KIND.CHANNEL,
  id,
  offset,
  index,
});

const defaultCategoryItemsMutator = ({ categoryChannels }) => categoryChannels;

export const guideGenerateListThunkAction = ({
  fetchParams,
  categoryHeight = 0,
  channelHeight = 0,
  categoryItemsMutator = defaultCategoryItemsMutator,
}) => async (dispatch, getState) => {
  await dispatch(linearChannelsFetchAllApiThunkAction(fetchParams));

  const state = getState();

  const channels = linearChannelsChannelListSelector(state);
  const categories = linearChannelsCategoryListSelector(state);

  const channelByCategories = groupByCategory({
    channels,
    categories,
  });

  const list = [];
  let index = 0;
  let offset = 0;

  channelByCategories.forEach((categoryChannels, name) => {
    if (Array.isArray(categoryChannels)) {
      offset += categoryHeight;

      const category = Object.values(categories).find((i) => i.name === name);

      const images = {
        pngImage:
          category && category.images ? category.images.find((img) => img.type === 'pngImage') : {},
      };

      list.push(
        categoryFactory({
          name,
          offset,
          index: index++,
          images,
        }),
      );

      const channelItems = categoryItemsMutator({ name, categoryChannels }).map(({ id }) => {
        offset += channelHeight;
        return channelFactory({ id, offset, index: index++ });
      });
      list.push(...channelItems);
    }
  });
  const featCat = channelByCategories.get('Featured');
  const featuredCategory = featCat
    ? { starstAtIndex: 1, endsAtIndex: featCat.length + 1, list: featCat }
    : undefined;
  return dispatch(guideSetListAction({ list, featuredCategory }));
};
